export const STALE_CHANNEL_NOTIIFICATION_FLAG =
  'STALE_CHANNEL_NOTIIFICATION_FLAG';
